
<template>

  <div class="bubble-outer" id="bubble-chart"></div>

</template>

<script>

import VueHighcharts from 'vue-highcharts';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
More(Highcharts);

import cToF from 'celsius-to-fahrenheit';

import { mapState } from 'vuex';

import Lang from '@/lib/langTemplates/FloorTemplate';

export default {

  data(){
    return {
      series: []
    }
  },

  props: ['rooms', 'rdg'],

  computed: {
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    setSeries(){
      const self = this;
      this.series = this.rooms.map(r => {
        let item = {
          name: r.info.hvacName,
          packedbubble: {
            shadow: {
              color: 'rgba(0, 0, 0, 0.8)',
              offsetX: '3px',
              offsetY: '3px',
              opacity: 1
            },
            plotOptions: {
              backgroundColor: 'white'
            }
          },
          tooltip: {},
          data: [{
            name: r.info.hvacName,
            value: r.meas && r.meas[this.rdg] && r.meas[this.rdg] !== 'no data' && r.meas[this.rdg] !== '-' ? this.rdg == 'voc' ? parseFloat(parseFloat(r.meas[this.rdg]).toFixed(2)) : Math.round(r.meas[this.rdg]) : -1,
            evt: r.did,
            term: setTerm(this.rdg, this.$store.state.user.metric, self.clauses.days)
          }]
        }
        if (item.data[0].value === -1) {
           item.data[0].color = 'white';
           item.data[0].color = 'white';
           item.tooltip.pointFormat = '<b>{point.name}</b> ' + this.rdg == 'voc' ? 'Calibrating...' : 'Awaiting Data'
        }
        if (this.rdg === 'ttp' && item.data[0].value !== -1) item.data[0].value = this.$store.state.user.metric ? item.data[0].value : Math.round(cToF(item.data[0].value));
        // if (r.meas[this.rdg] === 'no data') item.packedbubble.plotOptions.series.borderColor = 'white'
        if (this.rdg == 'days' && r.parent && typeof r.parent == 'string') {
          item.data.splice(0, 1);
        }
        return item;
      });
    },

    setChart(){
      const self = this;
      const chart = {
           chart: {
             type: 'packedbubble',
             height: '50%',
             // width: '100%',
             backgroundColor: 'none',
           },
           title: 'Buildings',
           tooltip: {
             useHTML: true,
             pointFormat: '<b>{point.name}:</b> {point.value}{point.term}'
           },
           legend: false,
           plotOptions: {
             series: {
               cursor: 'pointer',
               point: {
                 events: {
                   click() {
                     self.navRoom(this.evt)
                   }
                 }
               }
             },
             packedbubble: {
               minSize: '50%',
               maxSize: '95%',
               zMax: 600,
               animation: false,
               layoutAlgorithm: {
                 splitSeries: false,
                 gravitationalConstant: 0.05,
                 bubblePadding: 8,
                 friction: 0.5,
                 initialPositions: 'circle',
                 enableSimulation: true
               },
               dataLabels: {
                 useHTML: true,
                 enabled: true,
                 format: '{point.value}' !== -1 ?  `<span style="font-size:1.6em;">{point.value} {point.term}</span><br />` : `no data`,
                 align: 'center',
                 filter: {
                   property: 'y',
                   operator: '>',
                   value: 0
                 },
                 style: {
                   color: 'lightblue',
                   textOutline: 'black',
                   fontWeight: 'normal',
                   fontSize: '9px'

                 }
               }
             }
           },
           credits: false,
           series: this.series
         }
        if (this.rdg === 'co2') {
          // chart.plotOptions.packedbubble.minSize = '110px';
          chart.plotOptions.packedbubble.maxSize = '200px';
        }
        this.target = Highcharts.chart('bubble-chart', chart);
    },

    navRoom(id){
      this.$store.dispatch('setRoom', {id: id, breakpoint: this.$screen.breakpoint});
    }

  },

  mounted(){
    this.setSeries();
    this.setChart();
  },

  watch: {
    'rdg': function(newData, oldData){
      this.setSeries();
      this.setChart();
    },
    '$store.state.user.metric': function(newData, oldData){
      this.setSeries();
      this.setChart();
    }
  }

}

function setTerm(rdg, metric, days){
  let term;
  switch (rdg) {
    case 'days':
      term = days;
    break;
    case 'ttp':
      term = `˚${metric ? 'C' : 'F'}`;
    break;
    case 'hhm':
      term = '%';
    break;
    case 'iaq':
      term = '';
    break;
    case 'co2':
      term = 'ppm';
    break;
    case 'voc':
      term = 'ppm';
  }
  return term;
}

</script>

<style>

.bubble-outer {
  width: 100%;
  margin-bottom: 300px;
  /* height: 100%; */
}

/* .highcharts-point {
  margin-bottom: 100px;
} */

</style>



// WEBPACK FOOTER //
// src/components/floor/Bubble.vue